export const THOUSANDS_SEPARATOR = ",";
export const DECIMAL_SEPARATOR = ".";
